import { CALENDAR_DATE_TYPES, CALENDAR_TYPES } from "../../../../constants/calendarConstants";

/**
 * Build dateSettings from selectedDates and existing dateSettings.
 * - sorts selectedDates (ISO strings)
 * - preserves existing types for matching dates
 * - new dates get INSET if existingSettings.length > 0, otherwise HOLIDAY/REGULAR
 *
 * @param {string[]} selectedDates
 * @param {{date:string,type:any}[]} dateSettings
 * @param {string|number} calendarType
 * @returns {{date:string,type:any}[]}
 */
export function buildDateSettings(selectedDates = [], dateSettings = [], calendarType) {
  const selectedDatesSorted = [...selectedDates].sort();
  const dateSettingsMap = new Map(dateSettings.map((item) => [item.date, item.type]));

  const newDateType =
    dateSettings.length > 0
      ? CALENDAR_DATE_TYPES.INSET.id
      : calendarType === CALENDAR_TYPES.HOLIDAY.id
        ? CALENDAR_DATE_TYPES.HOLIDAY.id
        : CALENDAR_DATE_TYPES.REGULAR.id;

  return selectedDatesSorted.map((isoDate) => {
    const exitingDateType = dateSettingsMap.get(isoDate);

    if (exitingDateType !== undefined) {
      return { id: isoDate, date: isoDate, type: exitingDateType };
    }

    return { id: isoDate, date: isoDate, type: newDateType };
  });
}
